/**
 * Generated by orval v8.5.3 🍺
 * Do not edit manually.
 * Space Invoices API
 * REST API for invoice management, customer management, and accounting operations. Features include cursor-based pagination for efficient data navigation, flexible JSON querying with MongoDB-style operators, full-text search across multiple fields, and comprehensive metadata support for custom tracking.
 * OpenAPI spec version: 1.0.0
 */

/**
 * Tax residency status for Slovenian yearly reporting.
 * @nullable
 */
export type UpdateSloveniaTaxProfileBodyTaxResidency = typeof UpdateSloveniaTaxProfileBodyTaxResidency[keyof typeof UpdateSloveniaTaxProfileBodyTaxResidency] | null;


export const UpdateSloveniaTaxProfileBodyTaxResidency = {
  resident: 'resident',
  non_resident: 'non_resident',
} as const;
